var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFaq = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02936 0 0 4.0295 0 9C0 13.9708 4.02936 18 9 18C13.9706 18 18 13.9708 18 9C18 4.0295 13.9706 0 9 0ZM9 13.5C8.37865 13.5 7.875 12.9966 7.875 12.375C7.875 11.7537 8.37865 11.25 9 11.25C9.62135 11.25 10.125 11.7537 10.125 12.375C10.125 12.9966 9.62135 13.5 9 13.5ZM9.85915 8.83027C9.68171 8.90332 9.5625 9.10273 9.5625 9.32629V9.5625C9.5625 9.87342 9.31092 10.125 9 10.125C8.68908 10.125 8.4375 9.87342 8.4375 9.5625V9.32629C8.4375 8.64239 8.82696 8.03925 9.42957 7.79038C9.92176 7.58658 10.2003 7.07351 10.1063 6.54177C10.0289 6.09901 9.65095 5.72108 9.20876 5.64363C8.86598 5.5832 8.53583 5.67056 8.27712 5.88807C8.02167 6.10291 7.875 6.41711 7.875 6.75C7.875 7.06092 7.62342 7.3125 7.3125 7.3125C7.00158 7.3125 6.75 7.06092 6.75 6.75C6.75 6.08368 7.04278 5.45527 7.55364 5.02625C8.06396 4.59777 8.73686 4.41925 9.40317 4.53572C10.3107 4.69501 11.0555 5.4399 11.2148 6.34736C11.4 7.40204 10.843 8.42323 9.85915 8.83027Z",
    fill: "#82878D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFaq, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/faq.ec2d9bed.svg";
export { ForwardRef as ReactComponent };